module.exports = __webpack_public_path__ + "img/d8f6de9.png";